import { Link } from 'react-router-dom'

export default function NotFound() {
  return (
    <div className="min-h-screen flex items-center justify-center px-6">
      <div className="glass-card p-10 text-center max-w-sm">
        <p className="text-text-muted text-sm mb-2">Erreur 404</p>
        <h1 className="text-2xl font-bold text-text-primary mb-4">Page introuvable</h1>
        <Link to="/" className="glass-btn-accent px-5 py-2.5 text-sm rounded-xl inline-block">
          Retour à l'accueil
        </Link>
      </div>
    </div>
  )
}
